import { X } from '@tamagui/lucide-icons';
import { Button } from '@unistocks/components/button/button';
import { Column, Row } from '@unistocks/components/layout/flex';
import { Text } from '@unistocks/components/text/text';
import { memo } from 'react';
import { Dialog, ViewProps, useAdaptIsActive } from 'tamagui';

export type ModalHeaderProps = Omit<ViewProps, 'children'> & {
  title?: string;
  subtitle?: string;
  icon?: React.ReactNode;
  closeButton?: boolean;
};

export const ModalHeader = memo<ModalHeaderProps>(
  ({ title, subtitle, icon, closeButton = true, ...props }) => {
    const isAdapted = useAdaptIsActive();
    return !isAdapted && (title || icon) ? (
      <Row
        mb={'$3'}
        mx={'$-3'}
        px={'$3'}
        pb={'$2'}
        gap={'$3'}
        justifyContent="space-between"
        alignItems={'center'}
        borderBottomWidth={1}
        borderColor={'$borderColor'}
        {...props}
      >
        {icon}
        {title && subtitle ? (
          <Column maxWidth={'80%'} mr={'auto'}>
            <Dialog.Title size={'$6'} color={'$headingFont'}>
              {title}
            </Dialog.Title>
            <Text size={'$3'} color={'$color'} opacity={0.6}>
              {subtitle}
            </Text>
          </Column>
        ) : title ? (
          <Dialog.Title size={'$8'} color={'$headingFont'} mr={'auto'}>
            {title}
          </Dialog.Title>
        ) : null}
        {closeButton ? (
          <Dialog.Close asChild>
            <Button circular Icon={X} ml={'auto'} size="$2.5" />
          </Dialog.Close>
        ) : null}
      </Row>
    ) : null;
  }
);

ModalHeader.displayName = 'ModalHeader';
